import axios from 'axios'
import store from "../store/index";
import { showToast } from 'vant';

// 创建axios
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 60000 // request timeout
})
// 添加请求拦截器
service.interceptors.request.use(function(config) {

  config.headers.Authorization = config.token ? config.token : store.state.token ? store.state.token :
    null;

  if (config.method == "get") {
    if (!config.params) {
      config.params = {};
    }
    // if (store.state.userInfo.channelUid) {
    //   config.params.channelUid = store.state.userInfo.channelUid;
    // }
    
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      config.params.os_type = 'ios';
    }

    // if (store.state.app.os) {
    //   config.params.os_type = store.state.app.os;
    // }

    // if (store.state.app.fromType) {
    //   config.params.fromType = store.state.app.fromType;
    // }
  }

  if (config.method == "post") {
    if (!config.data) {
      config.data = {};
    }
    // if (store.state.userInfo.channelUid) {
    //   config.data.channelUid = store.state.userInfo.channelUid;
    // }
    
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      config.data.os_type = 'ios';
    }

    // if (store.state.app.os) {
    //   config.data.os_type = store.state.app.os;
    // }

    // if (store.state.app.fromType) {
    //   config.data.fromType = store.state.app.fromType;
    // }
  }

  return config;
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function(response) {
  // 对响应数据做点什么
  const res = response.data
  if (res.code == 403) {
    showToast('登录错误!')
  }else{
    return response;
  }
  
}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default service;